module.exports = __webpack_public_path__ + "static/media/Picture-perfect-Web-Dining-Experiences.ff1ef07c.webp";